import { render, staticRenderFns } from "./GaSpinner.vue?vue&type=template&id=122f6472&scoped=true&"
import script from "./GaSpinner.vue?vue&type=script&lang=js&"
export * from "./GaSpinner.vue?vue&type=script&lang=js&"
import style0 from "./GaSpinner.vue?vue&type=style&index=0&id=122f6472&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122f6472",
  null
  
)

export default component.exports